import { createI18n } from 'vue-i18n'
// 默认语言（zh-CN）随主包加载，保证首屏零等待；
// 其余语言包按需异步加载，不进首屏产物
import zhCN from './zh-CN.json'

const LOCALE_KEY = 'app-locale'
const SUPPORTED_LOCALES = ['zh-CN', 'en']

function getStoredLocale() {
  const stored = localStorage.getItem(LOCALE_KEY)
  if (SUPPORTED_LOCALES.includes(stored)) return stored
  return 'zh-CN'
}

const i18n = createI18n({
  legacy: true,
  locale: getStoredLocale(),
  fallbackLocale: 'zh-CN',
  messages: { 'zh-CN': zhCN }
})

/**
 * 语言包加载器：每种语言只加载一次
 * zh-CN 已内置，直接 resolve
 */
const localeLoaders = {
  'zh-CN': () => Promise.resolve(zhCN),
  en: () => import('./en.json')
}

const localePromises = new Map()

function loadLocaleMessages(locale) {
  if (!localePromises.has(locale)) {
    const promise = localeLoaders[locale]()
      .then(messages => messages?.default || messages)
      .then(messages => {
        i18n.global.setLocaleMessage(locale, messages)
        return messages
      })
      .catch(error => {
        // 加载失败时回滚，避免后续一直复用到失败结果
        localePromises.delete(locale)
        throw error
      })
    localePromises.set(locale, promise)
  }
  return localePromises.get(locale)
}

/**
 * 确保当前语言包已就绪（应用挂载前调用）
 */
export function ensureLocaleLoaded() {
  return loadLocaleMessages(i18n.global.locale).catch(() => {})
}

export async function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return
  try {
    await loadLocaleMessages(locale)
  } catch (error) {
    console.error(`Failed to load locale: ${locale}`, error)
    return
  }
  i18n.global.locale = locale
  localStorage.setItem(LOCALE_KEY, locale)
  document.documentElement.lang = locale === 'zh-CN' ? 'zh-CN' : 'en'
}

export { LOCALE_KEY, getStoredLocale }
export default i18n
